module.exports = __webpack_public_path__ + "img/introduce1.30c4250e.png";